// fcmTokenSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { updateFcmToken } from '../../utilities/services/fcmToken';

// Async thunk for updating the FCM token
export const updateFcmTokenThunk = createAsyncThunk(
  'fcmToken/update',
  async (payload, { rejectWithValue }) => {
    try {
      const data = await updateFcmToken(payload);
      return data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const fcmTokenSlice = createSlice({
  name: 'fcmToken',
  initialState: {
    status: 'idle', // idle | loading | succeeded | failed
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(updateFcmTokenThunk.pending, (state) => {
        state.status = 'loading';
        state.error = null;
      })
      .addCase(updateFcmTokenThunk.fulfilled, (state) => {
        state.status = 'succeeded';
      })
      .addCase(updateFcmTokenThunk.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload || 'An error occurred';
      });
  },
});

export default fcmTokenSlice.reducer;
